import HarvestKpiDashboardContainer from './containers/HarvestKpiDashboardContainer';

export default HarvestKpiDashboardContainer;
